export default "__VITE_ASSET__BrfTYoqX__"